<template>
    <app-layout>
        <div class="bax-banner-wrap">
            <div class="bax-banner-title-block" >
                <div class="container">
                    <div class="bax-banner-title d-flex align-items-center">
                        <img src="~@/assets/images/login-img.png" alt="Welcome">
                        <vue-heading :size="6">Rockingham General Hospital</vue-heading>
                        <!-- <strong class="ml-auto">Order Ref: {{ $route.params.id}}</strong> -->
                    </div>
                </div>
            </div>

            <div class="bax-banner-content d-flex align-items-end">
                <div class="container">
                    <h1 class="d-flex align-items-center">Manage Patient</h1>
                </div>
            </div>
        </div>

        <main>
            <div class="bax-section bax-select-patient-wrap">
              <div class="container">
                <div class="bax-bg bax-bg-white bax-create-patient pt-0">
                  <div class="bax-section-title">
                    <h1>Edit Patient Details</h1>
                  </div>
                  <div class="bax-form-wrapper">
                    <form novalidate @submit.prevent="updatePatient">
                      <ul>
                        <li class="bax-element-active">
                          <vue-input
                                placeholder="Patient ID"
                                v-model="formData.patientId"
                                label="Patient ID"
                                :error="errors.patientId"
                                @input="validateOnChange($event, 'patientId')"
                            />
                        </li>
                        <li>
                          <vue-input
                                placeholder="First name"
                                v-model="formData.firstName"
                                label="First name"
                                :error="errors.firstName"
                                @input="validateOnChange($event, 'firstName')"
                            />
                        </li>
                        <li>
                          <vue-input
                                placeholder="Last name"
                                v-model="formData.lastName"
                                label="Last name"
                                :error="errors.lastName"
                                @input="validateOnChange($event, 'lastName')"
                            />
                        </li>
                        <li>
                          <div
                                v-bind:class="errors.dateOfBirth != '' ? 'bax-error' : ''"
                            >
                                <label>Date of birth</label>
                                <datepicker
                                    @selected="onDateSelect"
                                    format="dd / MM / yyyy"
                                    placeholder="DD / MM / YYYY"
                                    :value="formData.dateOfBirth"
                                    :typeable="true"
                                ></datepicker>
                                <p v-if="errors.dateOfBirth != ''">{{ errors.dateOfBirth }}</p>
                            </div>
                        </li>
                        <li>
                          <div class="bax-form-element">
                            <label for="ward">Ward - <span>Optional</span></label>
                            <input type="text" id="ward" placeholder="yyyy">
                          </div>
                        </li>
                        <li>
                            <label for="ward">Doctor - <span>Optional</span></label>
                            <vue-input
                                placeholder="Doctor"
                            />
                        </li>
                      </ul>
                      <div class="bax-divider mb-0 mt-4"></div>
                      <div class="bax-cta-block d-md-flex">
                        <a
                            href="javascript:;"
                            class="bax-btn bax-btn-bordered bax-btn-bordered-blue"
                        >Back</a>
                        <input
                            type="submit"
                            value="Update patient"
                            class="bax-btn bax-btn bax-btn-blue ml-auto mt-3 mt-md-0"
                        >
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
        </main>
    </app-layout>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import AppLayout from '@/components/layout/AppLayout.vue';

export default {
    name: 'ManagePatient',
    components: {
        AppLayout,
        Datepicker,
    },
    data() {
        return {
            loading: true,
            formData: {
                patientId: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                wardId: '',
            },
            errors: {
                patientId: '',
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                wardId: '',
            },
        };
    },
    mounted() {
        this.$http.post('/api/v1/patient/search?_format=json', {
            firstName: '',
            lastName: '',
            medicalRecordNumber: this.$route.params.id,
        }, {
            headers: {
                'X-CSRF-Token': sessionStorage.getItem('X-CSRF-Token'),
            },
        })
            .then((res) => {
                const patient = res.data[0];

                this.formData.patientId = patient.patientID;
                this.formData.firstName = patient.firstName;
                this.formData.lastName = patient.lastName;
                this.formData.dateOfBirth = patient.dateOfBirth;
                this.formData.dateOfBirth = patient.dateOfBirth;
                this.formData.wardId = patient.wardId;

                this.loading = false;
            });
    },
    methods: {
        validateOnChange(a, b) {
            switch (b) {
                case 'patientId':
                    if (a === '') {
                        this.errors.patientId = 'Patient ID is required';
                    } else {
                        this.errors.patientId = '';
                    }
                    break;
                case 'firstName':
                    if (a === '') {
                        this.errors.firstName = 'First name is required';
                    } else {
                        this.errors.firstName = '';
                    }
                    break;
                case 'lastName':
                    if (a === '') {
                        this.errors.lastName = 'Last name is required';
                    } else {
                        this.errors.lastName = '';
                    }
                    break;
                case 'dateOfBirth':
                    if (a === '') {
                        this.errors.dateOfBirth = 'Date of birth is required';
                    } else {
                        this.errors.dateOfBirth = '';
                    }
                    break;
                default:
                    break;
            }
        },
        onDateSelect(e) {
            const formatedDate = moment(e).format('DD/MM/YYYY');
            this.formData.dateOfBirth = formatedDate;
            this.errors.dateOfBirth = '';
        },
        async updatePatient() {
            const formData = {
                id: this.formData.patientId,
                firstName: this.formData.firstName,
                lastName: this.formData.lastName,
                dateOfBirth: this.formData.dateOfBirth,
                wardId: this.formData.wardId,
                medicalRecordNumber: 59402,
            };

            this.$http.post('/api/v1/patient?_format=json', formData)
                .then(() => {
                    // this.created = true;
                });
        },
    },
};
</script>
